import Text from 'components/Text/Text';
import React, { useMemo } from 'react';
import { ISubCategoryAllDishes } from 'types';
import style from './DishesList.module.scss';

interface IDishesList {
	dishesOfSubcategory: ISubCategoryAllDishes[];
}

const DishesList: React.FC<IDishesList> = ({ dishesOfSubcategory }) => {
	const dishesList = useMemo(() => {
		return dishesOfSubcategory.map((el) => (
			<div className={style.item} key={el.id}>
				<div className={style.dot} />
				<Text translationKey={el.dishName} withTooltip={true} />
			</div>
		));
	}, [dishesOfSubcategory]);

	return (
		<div className={style.listOfItems} data-test="DishesList">
			{dishesOfSubcategory.length ? dishesList : '-'}
		</div>
	);
};

export default React.memo(DishesList);
